module.exports = {
      id: "Economy-usage",
      viewBox: "0 0 143 145",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/simulator/sprite.svg#Economy-usage",
      toString: function () {
        return this.url;
      }
    }